
import gql from 'graphql-tag'

// """查询商品列表(经销商)"""
export const findGoods = gql`
  query($order: [GoodsFindOrder!], $paging: PagingQuery, $where: GoodsFindFilter) {
    findGoods(
      order: $order,
      paging: $paging,
      where: $where,
    ) {
      goods {
        author
        createdAt
        coverImages
        dealerRelations {
          dealer {
            id
            realname
            storeName
            storePhone
            status
            user {
              phone
            }
          }
          dealerId
          details
          goodId
          price
          sharingProportion
        }
        details
        id
        isbn
        managers {
          createdBy {
            id
            username
          }
          modifiedBy {
            id
            username
          }
        }
        press
        price
        publishedDate
        status
        subTitle
        thumb
        title
        updatedAt
      }
      paging {
        currentOffset
        take
        totalCount
      }
    }
  }
`

// """删除商品"""
export const deleteGood = gql`
  mutation($goodId: Int!) {
    deleteGood(
      goodId: $goodId,
    )
  }
`

// """更改商品状态"""
export const changeGoodsStatus = gql`
  mutation($goodIds: [Int!]!, $status: GoodStatus!) {
    changeGoodsStatus(
      goodIds: $goodIds,
      status: $status
    )
  }
`

// """通过 id 查询商品(经销商)"""
export const findGood = gql`
  query($goodId: Int!) {
    findGood(
      goodId: $goodId
    ) {
      author
      createdAt
      dealerRelations {
        dealer {
          id
          realname
          storeName
          storePhone
          status
          user {
            phone
          }
        }
        details
        price
        sharingProportion
      }
      coverImages
      details
      id
      isbn
      managers {
        createdBy {
          id
          username
        }
        modifiedBy {
          id
          username
        }
      }
      press
      price
      publishedDate
      status
      subTitle
      thumb
      title
      updatedAt
      deliveryMethod
    }
  }
`

//   小店打烊或开门

export const openOrCloseStore = gql`
  mutation($dealerId: Int, $isOpening: Boolean!) {
    openOrCloseStore(
      dealerId: $dealerId,
      isOpening: $isOpening
    )
  }
`

export const exportGoodsList = gql`
  query($order: [GoodsFindOrder!],$where: GoodsFindFilter) {
    exportGoodsList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`
